import { render } from "./FinantialAccountCRUD.vue?vue&type=template&id=603c950e&scoped=true"
import script from "./FinantialAccountCRUD.vue?vue&type=script&lang=js"
export * from "./FinantialAccountCRUD.vue?vue&type=script&lang=js"

import "./FinantialAccountCRUD.vue?vue&type=style&index=0&id=603c950e&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603c950e"]])

export default __exports__